import DomainManager from '../../shared/utils/DomainManager';

export const getTravelerLink = (pathName: string, targetEnv: string) => {
  const domainManager = new DomainManager(targetEnv);

  return `${domainManager.getTravelerServiceDomain()}${pathName}`;
};
